import Modal from "@components/Modal";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { cdn },
  },
} = getConfig();

const CivExampleModal = () => (
  <Modal id="CivExampleModal" header="Legenda talon" size="large">
    <img
      src={`${cdn}/media/rca/talon.png`}
      alt="Exemplu certificat de inmatriculare"
      className="w-full"
    />
  </Modal>
);

export default CivExampleModal;
